<template>
<div class="event-list">
    <v-btn outlined @click="markAllRead">Mark all as read</v-btn>
    <notifications position="bottom right" group="notifications" />
    <div v-if="notifications" class="events-container">
        <Notification :key="notification.id" v-for="notification in notifications" :notification="notification" />
    </div>
</div>
</template>

<script>
import Notification from "@/components/atoms/Notification";

export default {
    created() {

        this.$notify({
            group: 'notifications',
            clean: true
        });
    },
    methods: {
        async markAllRead() {
            if (!this.notifications[0]) {
                return
            }
            await this.$store.dispatch("markAllAsRead", {
                'timestamp': this.notifications[0]['timestamp']
            }).then((data) => {
                if (data?.data?.updated) {
                    this.$notify({
                        group: 'notifications',
                        title: "notifications",
                        type: 'success',
                        text: "All notifications read."
                    })
                } else {
                    this.$notify({
                        group: 'notifications',
                        title: "notifications",
                        type: 'error',
                        text: "Not possible to mark as read, try later."
                    })
                }

            });
        },
    },
    components: {
        Notification
    },
    props: ["notifications"],
};
</script>
